import { HateoasResourceService, Resource } from '@lagoshny/ngx-hateoas-client';
import {
  DeleteResourceCommand,
  PatchResourceCommand,
  PostResourceCommand,
  ResourceCommand,
  ResourceCommandStream,
} from './resource-command-stream.service';
import { SnapshotProvider } from './snapshot-provider';

// Goals:
// - Capture snapshot (storing state)
// - Post, Patch, Delete

export class ResourceContext<T extends Resource> {
  private modelSnapshot: T;

  private _key: string;
  public get key(): string {
    return this._key;
  }

  constructor(
    private model: T,
    private commandStream: ResourceCommandStream,
    private hateoasResourceService: HateoasResourceService,
  ) {
    this._key = ResourceContext.getResourceKey(model);
    this.captureSnapshot();
  }

  public static getResourceKey<T extends Resource>(resource: T) {
    return resource['_links']['self'].href;
  }

  private captureSnapshot() {
    this.modelSnapshot = SnapshotProvider.capture(this.model, false);
  }
  post(relationName: string, resource: any = {}, addToStream = true): ResourceCommand {
    this.captureSnapshot();
    const command = new PostResourceCommand(this.model, relationName, resource);

    if (addToStream) {
      this.commandStream.add(command);
    }

    return command;
  }

  //replace the model
  set(newModel: T | Partial<T>) {
    this.model = newModel as T;
  }

  //update the model
  update(newModel: T | Partial<T>) {
    this.model = Object.assign(this.model, newModel);
  }

  patch(addToStream = true): PatchResourceCommand<T> {
    const diff = SnapshotProvider.diff(this.modelSnapshot, this.model);
    this.captureSnapshot();

    const command = new PatchResourceCommand(this.model, diff, this.hateoasResourceService);

    if (addToStream) {
      this.commandStream.add(command);
    }

    return command;
  }

  delete(params: any = null, addToStream = true): ResourceCommand {
    const command = new DeleteResourceCommand(this.model, this.hateoasResourceService, params);

    if (addToStream) {
      this.commandStream.add(command);
    }

    return command;
  }

  flush(message = ''): Promise<void> {
    return this.commandStream.flush(message);
  }
}

export class ResourceHelper {
  public static GetKey(resource: Resource) {
    return resource['_links']['self'].href;
  }
}
